<template>
  <div class="configuracoes-container">
    <v-card class="config-card" elevation="4">
      <v-card-title class="card-header">
        <v-icon size="24" color="primary" class="me-2">mdi-cog-outline</v-icon>
        Configurações do Sistema
      </v-card-title>
      
      <v-card-text>
        <div class="development-notice">
          <v-alert 
            type="info" 
            variant="tonal" 
            class="mb-4"
            icon="mdi-hammer-wrench"
          >
            <div class="alert-content">
              <h3>🚧 Em Desenvolvimento</h3>
              <p>Esta módulo de configurações está sendo desenvolvido.</p>
              <p>Em breve você poderá:</p>
              <ul>
                <li>Configurar preferências do sistema</li>
                <li>Gerenciar usuários e permissões</li>
                <li>Personalizar relatórios</li>
                <li>Configurar notificações</li>
              </ul>
            </div>
          </v-alert>
        </div>
        
        <div class="coming-soon">
          <v-icon size="48" color="grey-lighten-1">mdi-clock-outline</v-icon>
          <p class="text-h6 mt-2 text-grey-darken-1">Lançamento em breve!</p>
          <p class="text-body-2 text-grey-darken-2">
            Estamos trabalhando para trazer as melhores funcionalidades de configuração para você.
          </p>
        </div>
      </v-card-text>
      
      <v-card-actions class="card-footer">
        <v-spacer />
        <v-btn 
          color="primary" 
          variant="elevated"
          @click="handleOk"
          class="ok-btn"
        >
          <v-icon start>mdi-check</v-icon>
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script setup>
import { inject } from 'vue'

defineOptions({ name: 'ConfiguracoesPage' })

const showSnackbar = inject('showSnackbar', null)

function handleOk() {
  showSnackbar?.('Módulo em desenvolvimento. Em breve disponível!', 'info')
}
</script>

<style scoped>
.configuracoes-container {
  padding: 24px;
  max-width: 600px;
  margin: 0 auto;
}

.config-card {
  border-radius: 16px;
  overflow: hidden;
}

.card-header {
  background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
  padding: 20px 24px;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.development-notice {
  margin-bottom: 24px;
}

.alert-content h3 {
  margin-bottom: 12px;
  color: #1e293b;
  font-size: 1.1rem;
}

.alert-content p {
  margin-bottom: 8px;
  color: #475569;
}

.alert-content ul {
  margin: 12px 0;
  padding-left: 20px;
}

.alert-content li {
  margin-bottom: 4px;
  color: #475569;
}

.coming-soon {
  text-align: center;
  padding: 32px 24px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.ok-btn {
  border-radius: 8px;
  font-weight: 600;
  min-width: 100px;
}
</style>
